import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import {MenuV2Component} from "../componentes/menu-v2/menu-v2.component";
import {AutorizacaoService} from "../services/autorizacao.service";
import {NavigationEnd, Router} from "@angular/router";
import {Subject, Subscription, timer} from "rxjs";
import {AtivacaoAssinaturaComponent} from "../ativacao-assinatura/ativacao-assinatura.component";
import {EmpresasService} from "../superadmin/services/empresas.service";
import {ConstantsService} from "./ConstantsService";
import {MonitoradorPedidos} from "./MonitoradorPedidos";
import {WhatsappService} from "../services/whatsapp.service";
import {StatusWhatsapp} from "../objetos/StatusWhatsapp";
import {DialogCloseResult, DialogRef, DialogService} from "@progress/kendo-angular-dialog";
import {TelaFecharLojaComponent} from "../tela-fechar-loja/tela-fechar-loja.component";
import {ImpressaoService} from "../services/impressao.service";
import {NotificationRef, NotificationService} from "@progress/kendo-angular-notification";
import {ConfiguracoesMiaService} from "../services/configuracoes-mia.service";
import {KendoPopupUtils} from "../lib/KendoPopupUtils";
import {SocketService} from "../services/socket.service";
import { EmpresaService } from "../services/empresa.service";

declare var $;

@Component({
  selector: 'app-fidelidade',
  templateUrl: './fidelidade.component.html',
  styleUrls: ['./fidelidade.component.scss']
})
export class FidelidadeComponent implements OnInit , OnDestroy {

  constructor(private router: Router, private renderer: Renderer2, private deviceService: DeviceDetectorService,
              private autorizacaoService: AutorizacaoService,
              private empresasService: EmpresasService, public constantsService: ConstantsService,
              public monitoradorPedidos: MonitoradorPedidos, private whatsappService: WhatsappService,
              private notificationService: NotificationService,
              private dialogService: DialogService, public impressaoService: ImpressaoService,
              private configuracoesMiaService: ConfiguracoesMiaService,
              private socketService: SocketService,
              private empresaService: EmpresaService) { }
  @ViewChild(MenuV2Component) menuV2: MenuV2Component;
  @ViewChild('template', { read: TemplateRef }) notificationTemplate: TemplateRef<any>;
  @ViewChild('templateImprimirRemoto', { read: TemplateRef }) notificationTemplateImprimirRemoto: TemplateRef<any>;
  @ViewChild('templateErro', { read: TemplateRef }) notificationTemplateErro: TemplateRef<any>;
  @ViewChild('templateQzTrayError', { read: TemplateRef }) templateQzTrayError: TemplateRef<any>;
  @ViewChild('appendTo', { read: ViewContainerRef }) public appendTo: ViewContainerRef;
  errosImpressao: any = []
  usuario: any = {};
  bloqueado = true;
  public innerWidth: any;
  tarefaMonitorar: any;
  possuiModuloChatbot: boolean;
  statusWhatsapp: StatusWhatsapp;
  empresa: any;
  timerAberto: any;
  possuiModuloFidelidade: boolean;
  possuiModuloPedidos: boolean;
  notificationImpressao: NotificationRef;
  notificacoesErros = []
  qzTrayNotificacao: NotificationRef;
  erroQzTray: string;
  qzTrayBotaoClicado = false;
  qzTrayLoading = false;
  qzTrayAbrirVisivel = true;
  modoGarcom: boolean;
  isMobile: boolean;
  configuracoesMia: any;
  statusBot  = '';
  miaLigada = false;
  modoTeste = false;
  servico: any = {};
  opened = true;
  modalFecharLoja = false;
  modalJobGerenciador = false;
  modalReabrir = false;
  mensagemNotificacao: string;
  exibirProcessando: boolean;
  isNovoPedidoV3Route = false;
  isProdutosV2Route = false;
  isWizardRoute = false;
  menuV2Lateral = false;
  menuLegado = true;
  private static readonly CHAVE_MENU_LEGADO = 'meucardapio-menu-legado';
  isInsightsRoute = false;
  isIframeCompactRoute = false;
  private routeEventsSub: Subscription;
  integracoesIfoodMonitorar: any = []
  static abraComoPopup(dialogService: DialogService, isMobile: boolean ): DialogRef {
    let altura: any = window.innerHeight - 100;
    if( isMobile ) {
      altura = '100%';
    }

    let largura: any = '100%';

    if( window.innerWidth > 600 ) {
      largura = 'calc(100% - ' + (window.innerWidth - 600) + 'px)';
    }

    const windowRef = dialogService.open({
      title: 'Fechar Loja',
      content: TelaFecharLojaComponent,
      minWidth: 250,
      width: largura,
      maxHeight: altura
    });

    const $divDialog = windowRef.dialog.location.nativeElement;

    if( $divDialog ) {
      const $divDialogContent = $divDialog.getElementsByClassName('k-dialog-content');

      if( $divDialogContent.length > 0 ) {
        $divDialogContent[0].classList.add('dialog-pagamento');
      }
    }

    const telaCartaoDeCreditoComponent: TelaFecharLojaComponent = windowRef.content.instance;
    telaCartaoDeCreditoComponent.inicialize(windowRef);

    return windowRef;
  }

 async ngOnInit() {
   this.carregueEscolhaDeMenu();
   this.updateNovoPedidoV3Route(this.router.url);
   this.routeEventsSub = this.router.events.subscribe((event: any) => {
     if (event instanceof NavigationEnd) {
       this.updateNovoPedidoV3Route(event.urlAfterRedirects || event.url);
     }
   });

   this.isMobile = this.deviceService.isMobile()

   this.impressaoService.onImpresssaoRemota.subscribe((data) => {
      if(data)
        this.exibaImprimindoRemotamente(data);

   })

   this.carregueMia();

   // Escalação da Mia V3: alerta painel-wide com som (padrão do alerta de
   // pedidos) — sem isto a escalada só aparecia para quem já estava com a
   // tela de conversas aberta, e o cliente ficava falando sozinho.
   this.socketService.on('mia3:escalacao').subscribe((dados: any) =>
     this.exibaAlertaEscalacaoMia(dados || {}));

   if(!this.isMobile) {
     console.log('assinando evento do impressão service')
     this.impressaoService.conectandoQzTray.subscribe((conectando) => {
       console.log('recebeu notificação: ' + conectando)
       if (conectando)
         this.exibaAlertaConectando()
       else
         this.fecheAlertaConectantoImpressora()

     })

     this.impressaoService.onErrosImpressao.subscribe( (erro: any) => {
       if(erro) this.exibaNotificacaoErros(erro)
     })
   } else {
     console.log('Dispositivo móvel, impressão não será ativada')
   }


    this.innerWidth = window.innerWidth;
    let usuarioLogado = this.autorizacaoService.getUser();

    if( usuarioLogado != null ) {
      this.usuario = usuarioLogado;
      this.modoGarcom = this.usuario.garcom
    }

    this.monitoreLogado();

    this.constantsService.empresa$.subscribe( (empresa: any) => {
      if( !empresa )     return;
      this.empresa = empresa;
      if (empresa.onboarding) this.abraNoMenuNovoSemEscolha();
      this.servico = empresa.horariosDoServico[0];
      this.integracoesIfoodMonitorar =
        this.empresa.integracoesIfood.filter((item: any) =>  (!item.desativado) && (item.orderApi || item.shippingApi))

      this.monitoreLojaFechada();

    });

    this.empresasService.obtenhaContrato().then(  (contrato: any) => {
      if(!contrato.ativo){
        this.abraModalAtivaoAssinatura(contrato);
      } else {
        this.bloqueado = false;
      }
    });

    this.autorizacaoService.usuarioLogado$.subscribe( (usuario) => {
      if( !usuario ) return;

      this.usuario = usuario;
      this.modoGarcom = this.usuario.garcom
    });

    this.constantsService.moduloChatbot$.subscribe( (data) => {
      this.possuiModuloChatbot = data;
    });
    this.constantsService.moduloFidelidade$.subscribe( (data) => {
      this.possuiModuloFidelidade = data;
    });

    this.constantsService.moduloPedido$.subscribe( (data) => {
      this.possuiModuloPedidos = data;
       if(data)
         this.monitoradorPedidos.inicieMonitoramentoLoja();
    });

    this.whatsappService.status$.subscribe( (status: StatusWhatsapp) => {
      if(!this.statusWhatsapp?.online && status.online) {
        this.whatsappService.notifiqueMensagensAntigas();
      }

      this.statusWhatsapp = status;
    });
  }

  private carregueMia() {
    this.configuracoesMiaService.configuracoes$.subscribe((configuracoesMia) => {
      if( !configuracoesMia ) return;

      this.configuracoesMia = configuracoesMia;
      //converte o status do chatbot em uma descrição
      if (this.configuracoesMia?.status === 'MODO_TESTE') {
        this.statusBot = 'em Modo teste';
        this.miaLigada = true;
        this.modoTeste = true;
      } else if (this.configuracoesMia?.status === 'ATIVADA') {
        this.statusBot = 'Ativado'
        this.miaLigada = true;
      } else {
        this.statusBot = 'Desativada';
        this.miaLigada = false;
        this.modoTeste = false;
      }
    });
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }


  exibaNotificacaoErros(erroImpressao: any){
    let tempoAberto = 1000 * 60; // 1 minuto para dar tempo ao usuário abrir o QZ Tray e tentar novamente
    let tempoAnimacao = 400;

    // Verifica se a mensagem de erro está relacionada ao QZ Tray não estar aberto
    if (typeof erroImpressao === 'string' && erroImpressao.includes('qz-tray está aberto')) {
      // Fecha qualquer notificação anterior de QZ Tray
      if (this.qzTrayNotificacao) {
        this.qzTrayNotificacao.hide();
      }

      // Resetar estados
      this.qzTrayLoading = false;
      this.qzTrayAbrirVisivel = true;
      this.qzTrayBotaoClicado = false;

      // Cria uma notificação usando o template com botão
      this.qzTrayNotificacao = this.notificationService.show({
        appendTo: this.appendTo,
        hideAfter: tempoAberto,
        content: this.templateQzTrayError,
        position: { horizontal: 'right', vertical: 'top' },
        animation: { type: 'slide', duration: tempoAnimacao },
        cssClass: 'qz-tray-notification',
        type: { style: 'none', icon: false }
      });

      return;
    }

    let notificationErro: any = this.notificationService.show({
      appendTo: this.appendTo,
      hideAfter: 1000 * 25, // 25 segundos para outras notificações
      content: erroImpressao,
      position: { horizontal: 'right', vertical: 'top' },
      animation: { type: 'slide', duration: tempoAnimacao },
      type: { style: 'error', icon: false }
    });

    notificationErro.erro = erroImpressao;

    this.notificacoesErros.forEach((item: NotificationRef) => {
      if ((item as any).erro === erroImpressao)
        item.hide();
    });

    this.notificacoesErros.push(notificationErro);
  }

  exibaAlertaConectando(){
   if(this.notificationImpressao ) this.notificationImpressao.hide();

    this.notificationImpressao =  this.notificationService.show({
      appendTo: this.appendTo,
      content: this.notificationTemplate,
      hideAfter: 30000,
      position: { horizontal: 'right', vertical: 'top' },
      animation: { type: 'fade', duration: 400 },
      type: { style:  'info', icon: false}
    });

  }

  exibaImprimindoRemotamente(data: any){
    this.mensagemNotificacao  = data.mensagem;
    this.exibirProcessando  = data.processando ? true : false;
    //if(this.notificationImpressao ) this.notificationImpressao.hide();

    if(this.notificationImpressao ) this.notificationImpressao.hide();

    this.notificationImpressao =  this.notificationService.show({
      appendTo: this.appendTo,
      content: this.notificationTemplateImprimirRemoto,
      hideAfter: 10000 ,
      position: { horizontal: 'right', vertical: 'top' },
      animation: { type: 'fade', duration: 400 },
      type: { style:  'info', icon: false}
     // ,contentArgs: { msg } // mensagem dinâmica
    });
  }

  fecheAlertaConectantoImpressora(){
    if(  this.notificationImpressao)   this.notificationImpressao.hide();
  }

  monitoreLogado(){
    if(  this.tarefaMonitorar) return;

    this.tarefaMonitorar =  timer(0,  300 * 1000).subscribe( () => {
        this.verifiqueLogado();
    } )
  }

  verifiqueLogado(){
    if( window.location.pathname === '/admin/login') return;

    this.autorizacaoService.estaLogado().then( (resposta: any) => {
      if(!resposta.logado || this.autorizacaoService.getUser() === null)
        this.router.navigateByUrl('/admin/login?t=' + window.location.pathname)
    });
  }

  abraModalAtivaoAssinatura(contrato: any) {

    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: AtivacaoAssinaturaComponent,
      minWidth: 250,
      width: window.innerWidth - 50,
      maxHeight: window.innerHeight - 100,
      cssClass: 'bsModal'
    });


    KendoPopupUtils.abriuPopupNgBootstrap(windowRef)

    windowRef.content.instance.contrato = contrato;

    windowRef.result.subscribe( (result) => {
        window.location.reload();
      } );
  }

  /** Aba "Funções" do rodapé no celular: abre o mesmo menu do ☰, novo ou antigo. */
  abraMenu(): void {
    if (this.menuV2) this.menuV2.alternarMobile();
    else this.clicouHome();
  }

  clicouHome() {
    // Remove a classe show de todos os submenus
    const submenus = document.querySelectorAll('.nav-second-level.collapse.show');
    submenus.forEach(submenu => {
      submenu.classList.remove('show');
    });

    if(document.body.classList.contains('sidebar-enable'))
      this.renderer.removeClass(document.body, 'sidebar-enable')
    else
      this.renderer.addClass(document.body, 'sidebar-enable')

    if(this.innerWidth > 767){
      if(document.body.classList.contains('enlarged'))
        this.renderer.removeClass(document.body, 'enlarged')
      else
        this.renderer.addClass(document.body, 'enlarged')
    }
  }

  logout() {
    if(this.autorizacaoService.logout())  {
      this.router.navigate(['/admin/login'], { });
    }
  }

/*
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }
*/


  naoFacaNada() {
    return false;
  }

  /** `?menu=antigo` / `?menu=novo` força a escolha e fica salva — serve de saída se um dos menus quebrar. */
  private carregueEscolhaDeMenu(): void {
    try {
      const forcado = new URLSearchParams(window.location.search).get('menu');
      if (forcado === 'antigo' || forcado === 'novo') {
        localStorage.setItem(FidelidadeComponent.CHAVE_MENU_LEGADO, String(forcado === 'antigo'));
      }
      this.menuLegado = localStorage.getItem(FidelidadeComponent.CHAVE_MENU_LEGADO) !== 'false';
    } catch (_) {
      this.menuLegado = true;
    }
  }

  /** Loja com passo a passo (trial, Gestor, empresa final) abre no menu novo, onde está o menu simplificado; escolha salva continua valendo. */
  private abraNoMenuNovoSemEscolha(): void {
    try {
      if (localStorage.getItem(FidelidadeComponent.CHAVE_MENU_LEGADO) === null) this.menuLegado = false;
    } catch (_) {}
  }

  alterneMenuLegado(legado: boolean): void {
    this.menuLegado = legado;
    try { localStorage.setItem(FidelidadeComponent.CHAVE_MENU_LEGADO, String(legado)); } catch (_) {}
  }

  private updateNovoPedidoV3Route(url: string) {
    const sanitizedUrl = (url || '').split('?')[0].split('#')[0];
    const shouldEnableV3Shell = sanitizedUrl.indexOf('/pedidos/novo-v3') !== -1;
    this.isNovoPedidoV3Route = shouldEnableV3Shell;
    this.applyNovoPedidoV3BodyStyles(shouldEnableV3Shell);
    this.isProdutosV2Route = sanitizedUrl.indexOf('/produtos-v2') !== -1
      || sanitizedUrl.indexOf('/adicionais-v2') !== -1;
    this.isWizardRoute = sanitizedUrl.indexOf('/wizard') !== -1;
    this.isInsightsRoute = sanitizedUrl.indexOf('/admin/insights') !== -1 || sanitizedUrl.indexOf('/admin/analytics') !== -1;
    this.isIframeCompactRoute = sanitizedUrl.indexOf('/suporte/') !== -1 ||
      sanitizedUrl.indexOf('/contatos/iframe/') !== -1;
  }

  private applyNovoPedidoV3BodyStyles(enabled: boolean) {
    if (enabled) {
      this.renderer.setStyle(document.body, 'padding-bottom', '0px');
      this.renderer.setStyle(document.body, 'overflow-y', 'hidden');
      return;
    }

    this.renderer.removeStyle(document.body, 'padding-bottom');
    this.renderer.removeStyle(document.body, 'overflow-y');
  }

  ngOnDestroy(){
    if (this.routeEventsSub) {
      this.routeEventsSub.unsubscribe();
    }
    this.applyNovoPedidoV3BodyStyles(false);
    this.monitoradorPedidos.pareMonitoramento();
  }




  // ==== alerta de escalação da Mia V3 (som + modal, padrão do alerta de pedidos) ====
  escalacaoMia: { telefone: string; motivo: string } | null = null;
  private beepMia: any;
  private tarefaAlertaMia: Subscription | null = null;

  exibaAlertaEscalacaoMia(dados: any) {
    this.escalacaoMia = {
      telefone: String(dados.telefone || ''),
      // motivos técnicos viram texto legível (falha_tecnica → "falha tecnica")
      motivo: String(dados.motivo || '').replace(/_/g, ' '),
    };

    if (!this.tarefaAlertaMia) {
      this.beepMia = document.getElementById('beep-mia');
      if (this.beepMia) this.beepMia.load();
      // repete o som até o lojista fechar o modal — igual ao alerta de pedido
      this.tarefaAlertaMia = timer(0, 2000).subscribe(() => {
        this.beepMia?.play()?.catch(() => {});
      });
    }

    $('#alertaMiaEscalacao').modal();
    $('#alertaMiaEscalacao').off('hidden.bs.modal').on('hidden.bs.modal', () => this.pareAlertaEscalacaoMia());
  }

  pareAlertaEscalacaoMia() {
    if (this.beepMia) {
      this.beepMia.pause();
      this.beepMia.currentTime = 0;
    }
    if (this.tarefaAlertaMia) {
      this.tarefaAlertaMia.unsubscribe();
      this.tarefaAlertaMia = null;
    }
  }

  verConversaEscaladaMia() {
    $('#alertaMiaEscalacao').modal('hide');
    this.pareAlertaEscalacaoMia();
    this.router.navigate(['/admin/mia-v3/conversas']);
  }

  alterouStatusAlerta(event: any) {
    this.monitoradorPedidos.toogleTocarIframe();
  }

  clicouAlerta($event: MouseEvent) {
    $event.stopPropagation(); $event.preventDefault();
  }

  recarregarAbas() {
    this.socketService.atualizeAbas();
  }

  /** Telas roteadas (a home) não têm @Output para a casca: ouvem por aqui. */
  readonly lojaFechada = new Subject<any>();

  abraModalFecharLoja() {
    this.modalFecharLoja = true;
  }

  abraModalGerenciarJobs(){
    this.modalJobGerenciador = true;
  }

  fechouModalGerenciarJobs(result: any){
    this.modalJobGerenciador = false;
  }

  fechouLoja(result: any) {
    this.modalFecharLoja = false;
    if (result && result.fechou) {
      this.empresa.fechadoTemporariamente = true;
      this.verifiqueServicosAbertos();
    }

    this.monitoreLojaFechada();
    this.lojaFechada.next(result);
  }

  abraModalReabrirLoja(){
    this.modalReabrir = true;
  }

  reabriuLoja(result: any){
    this.modalReabrir = false;
    if (result && result.abriu) {
      this.empresa.fechadoTemporariamente = false;
      delete this.empresa.mensagemPausaProgramada;
      this.verifiqueServicosAbertos();

      if(this.timerAberto) this.timerAberto.unsubscribe();
    }
  }


  reabrir() {
    this.empresa.reabrindo = true;
    this.empresasService.abra().then( (resposta) => {
      this.empresa.reabrindo = false;
      this.verifiqueServicosAbertos();
    })
  }

  verifiqueServicosAbertos(){
    this.empresasService.logada().then( (_empresa: any) => {
      this.empresa.fechadoTemporariamente = _empresa.fechadoTemporariamente;
      if(  !_empresa.fechadoTemporariamente ){
        if(this.timerAberto)
          this.timerAberto.unsubscribe();
      }
      this.empresa.horariosDoServico = _empresa.horariosDoServico;
      this.servico =    this.empresa.horariosDoServico.find((item: any) => item.id === this.servico.id)
    });
  }

  private monitoreLojaFechada() {
    if(!this.servico.estaAberta || !this.servico.estaRecebendoPedidos){
      if(this.timerAberto) this.timerAberto.unsubscribe();

      const segundosTimer = 60;

      this.timerAberto =  timer(1000 * segundosTimer , 1000 * segundosTimer  ).subscribe( () => {
        this.verifiqueServicosAbertos();
      })
    }
  }

  clicouNaoImprimir($event: MouseEvent) {
    $event.stopPropagation(); $event.preventDefault();
  }

  alterouNaoImprimir($event: any) {
    this.monitoradorPedidos.toogleNaoImprimir();
  }

  alterouNaoTocarGarcom($event: any): void {
    this.monitoradorPedidos.toogleNaoTocarGarcom();
  }

  mudouServico($event){
    this.servico = $event;
  }

  abraQZTrayNotificacao() {
    // Ativar loading e desabilitar botões
    this.qzTrayLoading = true;

    // Abrir QZ Tray
    window.location.href = 'qz:launch';

    // Após 5 segundos, esconder botão de abrir e reabilitar tentar novamente
    setTimeout(() => {
      this.qzTrayLoading = false;
      this.qzTrayAbrirVisivel = false;
    }, 5000);
  }

  tenteConectarQZManualmente() {
    // Esconde a notificação de erro do QZ Tray
    if (this.qzTrayNotificacao) {
      this.qzTrayNotificacao.hide();
    }

    // Resetar estados
    this.qzTrayLoading = false;
    this.qzTrayAbrirVisivel = true;

    // Exibe mensagem de conectando
    this.exibaAlertaConectando();

    // Tenta conectar ao QZ Tray
    this.impressaoService.possuiQZ().then((possui: boolean) => {
      // Esconde mensagem de conectando
      this.fecheAlertaConectantoImpressora();

      if (!possui) {
        // Se falhar, exibe mensagem de erro novamente
        this.exibaNotificacaoErros('Não foi possível conectar a impressora. O qz-tray está aberto?');
      }
    });
  }

  fecharNotificacaoQzTray() {
    if (this.qzTrayNotificacao) {
      this.qzTrayNotificacao.hide();
    }
    // Resetar estados
    this.qzTrayLoading = false;
    this.qzTrayAbrirVisivel = true;
  }


  clicouLojaKeeta() {
    this.monitoradorPedidos.autalizeStatusKeeta()
    this.router.navigateByUrl('/admin/loja/tab/keeta')
  }

  /** Painel compartilhado de canais de venda: mantém as operações existentes do parceiro. */
  alterneIntegracao(evento: {tipo: 'ifood' | 'keeta' | '99food', loja: any, abrir: boolean}) {
    if (evento.tipo === 'keeta') evento.abrir ? this.abrirKeeta(evento.loja) : this.fecharKeeta(evento.loja);
    if (evento.tipo === '99food') evento.abrir ? this.abrirLoja99Food(evento.loja) : this.fecharLoja99Food(evento.loja);
  }

  // Ações do status da Keeta (hover popover)
  abrirKeeta(keetaLoja: any) {
    keetaLoja.processando = true;
    this.empresaService.abrirLojaKeeta().then(() => {
      this.monitoradorPedidos.autalizeStatusKeeta();
      keetaLoja.processando = false;
    });
  }

  fecharKeeta(keetaLoja: any) {
    keetaLoja.processando = true;
    this.empresaService.fecharLojaKeeta().then(() => {
      this.monitoradorPedidos.autalizeStatusKeeta();
      keetaLoja.processando = false;
    });
  }

  abrirLoja99Food(loja: any){
    loja.processando = true;
    this.empresaService.abrirLoja99Food(loja).then((resposta: any) => {
      loja.mensagem = resposta.mensagem;
      loja.aberta = true;
      loja.ultimaAtualizacaoStatus = new Date();
      loja.processando = false;
    }).catch((err) => {
      loja.processando = false;
      alert(err)
    })
  }

  fecharLoja99Food(loja: any){
    loja.processando = true;

    this.empresaService.fecharLoja99Food(loja).then((resposta: any) => {
      loja.aberta = false;
      loja.mensagem = resposta.mensagem;
      loja.ultimaAtualizacaoStatus = new Date();
      loja.processando = false;
    }).catch((err) => {
      loja.processando = false;
      alert(err)
    })
  }


}
